export default __webpack_public_path__ + "static/media/no_result.825635cf.gif";